<template>
  <div class="video">
    <video-player class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @timeupdate="updateTime"
    >
    </video-player>
  </div>
</template>

<script>
  import {videoPlayer} from 'vue-video-player'

  export default {
    components: {
      videoPlayer
    },
    data () {
      return {
        playerOptions: {
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4',
            src: 'http://www.w3school.com.cn//i/movie.ogg' // 你的视频地址（必填）
          }],
          poster: '', // 你的封面地址
          notSupportedMessage: '此视频暂无法播放,请稍后再试',
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true
          }
        },
        allTimes: 0
      }
    },
    methods: {
      onPlayerPlay (player) { // 开始播放
        console.log('play')
      },
      onPlayerPause (player) { // 结束播放
        console.log('end')
      },
      updateTime (e) { // 播放时间
        this.allTimes = e.currentTime()
        console.log(this.allTimes)
      }
    },
    computed: {
      player () {
        return this.$refs.videoPlayer.player
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .video {
    width: 100%;
    height: 100%;

    .video-js .vjs-control {
      z-index: 99;
    }

    .video-js .vjs-control-bar {
      background-color: #1d1d1d;
      z-index: 99;
      // bottom: -14px;
    }

    .vjs-custom-skin > .video-js .vjs-play-progress, .vjs-custom-skin > .video-js .vjs-volume-level {
      background-color: #ff827b;
    }

    .video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active {
      background-color: #ff827b;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/video/video.vue